import request from './request'

// 登录
export function login (data) {
  return request.get('en/user/login', data)
}
// 修改密码
export function changePassword (data) {
  return request.post('en/user/modifyPassword', data)
}
// 重置密码
export function resetPassword (data) {
  return request.post('en/user/resetPassword', data)
}
// 注册
export function register (data) {
  return request.post('en/user/register', data, 'json')
}
// 获取用户信息
export function getUserInfo (data) {
  return request.get('en/user/mineInfo', data)
}
// 更新用户信息
export function updateUserInfo (data) {
  return request.post('en/user/update', data, 'json')
}
// 删除账号
export function selfDestruct (data) {
  return request.post('en/user/selfDestruct', data)
}
// 激活账号
export function availableAccounts (data) {
  return request.post('en/user/availableAccounts', data)
}
// 禁用/启用账号
export function updateAccountIsAvailable (data) {
  return request.post('en/user/updateAccountIsAvailable', data)
}
// 获取账号列表
export function getAccountList (data) {
  return request.get('en/user/userList', data)
}
// 删除账号
export function delAccount (data) {
  return request.post('en/user/deleteUser', data)
}
// 申请权限
export function grantPermission (data) {
  return request.post('en/user/grantPermission', data)
}
